import React from 'react';
import PropTypes from 'prop-types';
import css from './ServicesSection.scss';
import Title from '../../common/Title';
import { SFEntityID } from 'utils/types';
import { Link } from 'react-router-dom';
import { determineServiceName } from 'utils/search';

export default class ServicesSection extends React.Component {
  render() {
    return (
      <div>
        <Title text="Services" />
        <ul className={css['services-container']}>
          {this.props.services.map(({id, name, serviceDisplayName}, i) =>
            <li key={i}><
              Link to={`/service/${id}`}>{determineServiceName(name, serviceDisplayName, this.props.isStudent)}</Link>
            </li>)}
        </ul>
      </div>
    );
  }
}

ServicesSection.propTypes = {
  services: PropTypes.arrayOf(PropTypes.shape({
    id: SFEntityID.isRequired,
    name: PropTypes.string.isRequired,
    serviceDisplayName: PropTypes.string
  })).isRequired,
  isStudent: PropTypes.bool.isRequired
};
